import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ icon, style, onClick, title }) => (<i onClick={onClick} className={`fa fa-${icon}`} style={style} title={title}/>);

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
};

export default Icon;



// WEBPACK FOOTER //
// ./src/component/Icon/Icon.js